module.exports = __webpack_public_path__ + "img/antes_despues_62.98025962.png";